export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "15黑料网的内容和普通资讯有什么不同？",
    answer:
      "普通资讯告诉你「发生了什么」，我们更关注「为什么按这个顺序发生」。每篇解读都会拆成时间线、关键角色、疑点清单和逻辑复盘四部分，方便你按自己的判断力去核对，而不是接受一个现成结论。",
  },
  {
    question: "你们的事件案例是怎么选出来的？",
    answer:
      "优先选择公开信息相对完整、讨论热度较高、且存在明显信息断层的事件。判断标准是「这件事有没有值得被理清的结构」，而不是它有多热闹。",
  },
  {
    question: "解读里出现的人物和信息准确吗？",
    answer:
      "我们只使用公开可查证的信息，并在涉及具体个人时做匿名化处理。对于无法核实的内容，会明确标注为「待确认」或放进疑点清单，而不是当作事实写进时间线。",
  },
  {
    question: "为什么有的文章会更新或补充？",
    answer:
      "事件是会往前走的。当新的公开信息出现，影响到了原先的时间线或推论，我们会补充更新说明。保留修改记录，是我们对准确性的一种负责方式。",
  },
  {
    question: "可以投稿或者提供线索吗？",
    answer:
      "可以。欢迎通过页面下方的订阅与联系表单提供线索来源或公开链接。我们更看重可核验的原始材料，而不是单一转述，因此线索越具体、越接近一手信息，越容易被采纳。",
  },
  {
    question: "网站会收录读者的评论或观点吗？",
    answer:
      "目前我们聚焦在结构化的解读本身。若后续开放读者讨论区，会优先保证信息可追溯，而不是变成情绪宣泄的场所。",
  },
  {
    question: "阅读全部内容需要付费吗？",
    answer:
      "不需要。15黑料网目前的深度解读全部免费阅读，我们更希望内容被认真读完，而不是被门槛拦住。",
  },
  {
    question: "如何快速找到想看的事件？",
    answer:
      "可以在「深度解读」页按主题分类筛选，也可以直接输入关键词搜索。每个主题档案页都汇总了该方向下已完成的事件复盘，适合按兴趣成批浏览。",
  },
];